import { useState, useEffect, useContext, useRef } from "react";

import Backdrop from "@mui/material/Backdrop";
import Toolbar from "@mui/material/Toolbar";
import CircularProgress from "@mui/material/CircularProgress";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiButton from "components/SuiButton";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

import Rating from "@mui/material/Rating";
import Tooltip from "@mui/material/Tooltip";

import api from "services/api";
import storeApi from "services/store-api";

import toast from "react-hot-toast";

import moment from "moment";
import breakpoints from "assets/theme/base/breakpoints";
import colors from "assets/theme/base/colors";
import ReadMore from "components/UpStyled/ReadMore";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import FilePreviewCard from "components/UpStyled/FilePreviewCard";
import Comments from "pages/comment";
import { Empty } from "antd";

const ProductDetailModal = ({ visible, handleClose, handleOk, productId, styleImages }) => {
  const [detail, setDetail] = useState({});
  const [detailImage, setDetailImage] = useState(null);
  const [itemScore, setItemScore] = useState({});
  const [avgScore, setAvgScore] = useState({});

  const account = useContext(AccountContext);
  const statistic = account?.metadata?.statistic || {};
  const style_likes = account?.metadata?.style_likes || [];

  const styleMeta = detail?.style ? detail.style : {};
  let imageFiles = styleMeta?.imageFiles || [];
  if (styleImages && styleImages.length > 0) {
    imageFiles = styleImages;
  }

  useEffect(() => {
    if (productId) {
      retrieveStyleDetail(productId);
      retrieveAvgScore(productId);
    }
  }, [productId]);

  useEffect(() => {
    if (productId && account.id) {
      retrieveItemScore(productId);
    }
  }, [productId, account.id]);

  const retrieveStyleDetail = async (productId) => {
    try {
      if (productId) {
        const { data } = await storeApi.products.retrieve(productId);
        console.log(data);
        setDetail(data?.product || {});
      }
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveItemScore = async (productId) => {
    try {
      const myScore = await api.score.retrieve(productId);
      const score = myScore?.data?.score || {};
      setItemScore(score);
    } catch (err) {
      console.log(err);
    }
  };

  const updateStatisticScore = async (tab, score) => {
    if (score < 0.5) {
      score = 0.5;
    }
    try {
      let statistic = {};
      statistic[tab] = score;
      const { data } = await api.score.update(productId, statistic);
      setItemScore(data?.updated || {});
    } catch (err) {
      console.log(err);
    }
  };

  const handleThumbUpToggle = async () => {
    if (account?.id) {
      const style_likes = account?.metadata?.style_likes || [];
      const findIndex = style_likes.findIndex((x) => x == detail.id);
      if (findIndex == -1) {
        style_likes.push(detail.id);
        //updateAmount("like", 1);
      } else {
        style_likes.splice(findIndex, 1);
        //updateAmount("like", -1);
      }
      account.handleUpdate(account.id, { metadata: { style_likes: style_likes } });
    }
  };

  const retrieveAvgScore = async (id) => {
    try {
      const { data } = await api.score.retrieveAvgScore(id);
      setAvgScore(data?.score || {});
    } catch (err) {
      console.log(err);
    }
  };

  const statisticOptions = [
    {
      key: "trendiness",
      icon: <TrendingUpIcon sx={{ mr: 0.5, verticalAlign: "middle" }} fontSize="xsmall" />,
      value: avgScore?.avg_trendiness,
    },
    {
      key: "uniqueness",
      icon: <AutoAwesomeIcon sx={{ mr: 0.5, verticalAlign: "middle" }} fontSize="xsmall" />,
      value: avgScore?.avg_uniqueness,
    },
    {
      key: "popularity",
      icon: <FavoriteBorderIcon sx={{ mr: 0.5, verticalAlign: "middle" }} fontSize="xsmall" />,
      value: avgScore?.avg_popularity,
    },
  ];

  return (
    <Dialog
      open={visible}
      onClose={(e, reason) => {
        if (reason != "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">
        Product Details
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <SuiBox sx={{ px: 3 }}>
          {detail.id ? (
            <div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={7}>
                  <SuiBox
                    sx={{
                      width: "100%",
                      height: "100%",

                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SuiBox sx={{ minHeight: 400 }}>
                      {imageFiles && imageFiles.length > 0 ? (
                        <ImageCardWrapper
                          data={detailImage ? detailImage : imageFiles[0]}
                          mode={"normal"}
                          width={400}
                          height={500}
                          borderRadius="xl"
                          pdfPagination={true}
                          sx={{ width: "100%", height: "auto", minHeight: 400 }}
                        />
                      ) : (
                        <SuiBox
                          sx={{
                            overflow: "hidden",
                            width: "100%",
                            backgroundImage: ({
                              functions: { rgba, linearGradient },
                              palette: { gradients },
                            }) =>
                              `${linearGradient(
                                rgba(gradients.secondary.main, 0.2),
                                rgba(gradients.secondary.state, 0.4)
                              )}`,
                            height: "400px",
                            margin: 0,
                            boxShadow: ({ boxShadows: { md } }) => md,
                            objectFit: "contain",
                            objectPosition: "center",
                          }}
                          display="flex"
                          alignItems="center"
                          position="relative"
                          minHeight="400px"
                          borderRadius="xl"
                        />
                      )}
                    </SuiBox>

                    <SuiBox
                      mt={1}
                      px={4}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      {" "}
                      <SuiBox sx={{ overflowX: "auto" }}>
                        {imageFiles && imageFiles.length > 0 ? (
                          <FilePreviewCard
                            files={imageFiles}
                            setfiles={false}
                            handleDelete={false}
                            onFileClick={(file) => setDetailImage(file)}
                            iconOnly
                            isDragDisabled={true}
                          />
                        ) : (
                          <SuiBox sx={{ height: 140, px: 2 }} display="flex" alignItems="center">
                            <SuiTypography
                              variant="h6"
                              color="text"
                              fontWeight="regular"
                              textTransform="capitalize"
                            >
                              No available data!
                            </SuiTypography>
                          </SuiBox>
                        )}
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={5}>
                  <SuiBox>
                    <SuiBox display="flex" alignItems="center">
                      <SuiTypography variant="h5" fontWeight="bold">
                        {detail.title}
                      </SuiTypography>

                      {account?.id && account.id != detail.store_id ? (
                        style_likes.includes(detail?.id) ? (
                          <Tooltip title="Click to remove the style from likes.">
                            <FavoriteIcon
                              color={"error"}
                              sx={{
                                cursor: "pointer",
                                ml: 1,
                              }}
                              onClick={handleThumbUpToggle}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Click to like this style.">
                            <FavoriteBorderIcon
                              color={"#454545"}
                              sx={{
                                cursor: "pointer",
                                ml: 1,
                              }}
                              onClick={handleThumbUpToggle}
                            />
                          </Tooltip>
                        )
                      ) : null}
                    </SuiBox>
                    {/* <SuiBox mt={1}>
                      <SuiTypography variant="h6" fontWeight="medium">
                        Price
                      </SuiTypography>
                    </SuiBox>
                    <SuiBox mb={1}>
                      <SuiTypography variant="h5" fontWeight="medium">
                        $--
                      </SuiTypography>
                    </SuiBox> */}
                    <SuiBox display="flex" justifyContent="space-between" flexWrap="nowrap" mt={1}>
                      {statisticOptions.map((so) => (
                        <SuiTypography
                          variant={"body1"}
                          color={"dark"}
                          sx={{
                            textTransform: "capitalize",
                            whiteSpace: "nowrap",
                            verticalAlign: "middle",
                          }}
                        >
                          {so.icon}
                          {so.key}
                          {so?.value ? `(${so.value.toFixed(1)})` : null}
                        </SuiTypography>
                      ))}
                    </SuiBox>

                    <SuiBox mt={1}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={5} lg={4}>
                          <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                            <SuiTypography component="label" variant="button" fontWeight="bold">
                              Colorway
                            </SuiTypography>
                          </SuiBox>
                          {detail?.style?.color_way && detail.style.color_way.length > 0 ? (
                            <SuiTypography
                              variant="body1"
                              textTransform="none"
                              color="text"
                              sx={{ ml: 0.5 }}
                            >
                              {detail.style.color_way.map((x) => x.label).join(", ")}
                            </SuiTypography>
                          ) : (
                            <SuiTypography
                              variant="body1"
                              textTransform="none"
                              color="text"
                              sx={{ ml: 0.5 }}
                            >
                              N/A
                            </SuiTypography>
                          )}
                        </Grid>
                        <Grid item xs={12} md={5} lg={4}>
                          <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                            <SuiTypography component="label" variant="button" fontWeight="bold">
                              Size
                            </SuiTypography>
                          </SuiBox>
                          {detail?.style?.size && detail.style.size.length > 0 ? (
                            <SuiTypography
                              variant="body1"
                              textTransform="none"
                              color="text"
                              sx={{ ml: 0.5 }}
                            >
                              {detail.style.size.map((x) => x.label).join(", ")}
                            </SuiTypography>
                          ) : (
                            <SuiTypography
                              variant="body1"
                              textTransform="none"
                              color="text"
                              sx={{ ml: 0.5 }}
                            >
                              N/A
                            </SuiTypography>
                          )}
                        </Grid>
                      </Grid>
                    </SuiBox>
                    <SuiBox>
                      <SuiBox mb={1} ml={0.5} mt={1}>
                        <SuiTypography
                          variant="button"
                          fontWeight="bold"
                          textTransform="capitalize"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          Description:
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox
                        mb={1}
                        ml={0.5}
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="top"
                        gap={1}
                      >
                        <SuiTypography variant="body1" textTransform="none" color="text">
                          {detail?.description ? (
                            <ReadMore
                              limit={1200}
                              variant="body1"
                              textTransform="none"
                              color="text"
                            >
                              {detail.description}
                            </ReadMore>
                          ) : (
                            "There is no description for this style."
                          )}
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>
                    <SuiBox>
                      {account?.id &&
                        statisticOptions.map((so, index) => (
                          <SuiBox
                            display="flex"
                            alignItems="center"
                            justifyContent="flex-start"
                            key={index}
                          >
                            <SuiBox sx={{ minWidth: 120 }}>
                              <SuiButton
                                variant={"text"}
                                color={"dark"}
                                sx={{
                                  textTransform: "capitalize",

                                  fontSize: 12,
                                  lineHeight: 0,
                                  minHeight: 25,
                                  minWidth: 80,
                                  borderRadius: "4px",
                                }}
                                size="small"
                              >
                                {so.icon}
                                {so.key}
                              </SuiButton>
                            </SuiBox>
                            <Rating
                              key={"rating_" + index}
                              name={"rating_" + index}
                              id={"rating_" + index}
                              value={itemScore?.[so.key] || 0}
                              precision={0.5}
                              onChange={(event, newValue) => {
                                console.log(event, newValue);
                                setItemScore({ trendiness: newValue });
                                updateStatisticScore(so.key, newValue);
                              }}
                              readOnly={account.id == detail.store_id}
                            />
                            <SuiTypography>{itemScore?.[so.key]}</SuiTypography>
                          </SuiBox>
                        ))}
                    </SuiBox>
                    {/* {account?.id ? (
                      <SuiBox sx={{ maxHeight: 300, overflow: "auto", mt: 1 }}>
                        <Comments subjectid={"portfolio_" + detail.id} size="sm" />
                      </SuiBox>
                    ) : null} */}
                  </SuiBox>
                </Grid>
              </Grid>
            </div>
          ) : (
            <Empty description="Could not find the style!" />
          )}
        </SuiBox>
      </DialogContent>
    </Dialog>
  );
};

export default ProductDetailModal;
